import { useState } from "react"
import { Trans, useTranslation } from "next-i18next"

import SignUpSteps from "../components/local/SignUpSteps"
import Styles from "./sign-up.module.scss"
import Footer from "../components/local/Footer"
import Header from "../components/Header"
import AdvantagesList from "../components/local/SignUp/AdvantagesList"
export { getServerSideProps } from "../utils/getServerSideProps"

function SignUp() {
  const { t } = useTranslation("common")
  const [step, setStep] = useState(0)

  const advantages = (
    <div className="mb-10 md:mb-10 w-full">
      <AdvantagesList step={step} />
    </div>
  )

  const signUpSteps = (
    <div className="mt-10 mb-10 w-full ">
      <SignUpSteps step={step} setStep={setStep} />
    </div>
  )

  return (
    <>
      <Header />
      <div className={Styles.Wrapper} id="page-wrap">
        <h1 className="text-2xl md:text-3xl font-bold font-sans tracking-wider  text-center md:text-left">
          <Trans
            i18nKey="SIGNUP_PERSONALIZE_JOURNEY"
            values={{
              appName: t("APP_NAME"),
            }}
            components={{
              appName: (
                <span style={{ color: "#0019FF" }}>{t("APP_NAME")}</span>
              ),
            }}
          />
        </h1>

        <div className={Styles.WrapperAdvSign}>
          {advantages}
          {signUpSteps}
        </div>
      </div>

      <Footer />
    </>
  )
}

export default SignUp
